module.exports = __webpack_public_path__ + "static/media/la-solid-900.36fc2979.woff2";